const style = () => ({
    root: {
        textAlign: "center",
    },
    dropzoneContainer: {
        marginTop: "10px",
        padding: "10px 15px 15px 15px",
        border: "1px dashed rgba(0, 0, 0, 0.4)",
        textAlign: "center",
        cursor: "pointer",
    },
    dropzone: {
        background:
            // eslint-disable-next-line
            'url(\'data:image/svg+xml;utf-8,<svg aria-hidden="true" data-prefix="fas" data-icon="upload" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-upload fa-w-16 fa-7x"><path fill="#aaa" d="M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z" class=""></path></svg>\')',
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        fontSize: "5rem",
        height: "50px",
        margin: "10px 0 0 0",
    },
    imgThumbnail: {
        border: "1px solid #ddd",
        borderRadius: "2px",
        padding: "3px",
        marginBottom: "10px",
        position: "relative",
    },
    imgThumbnailImg: {
        maxWidth: "100%",
    },
    imgThumbnailBtn: {
        position: "absolute",
        top: "-5px",
        right: "-5px",
        width: "35px",
        height: "35px",
        backgroundColor: "#fff",
        padding: "0",
        borderRadius: "50%",
        fontSize: "1rem",
        cursor: "pointer",
    },
    underline: {
        textDecoration: "underline",
    },
    spacingDown: {
        marginBottom: "30px",
    },
    spacingUp: {
        marginTop: "30px",
    },
    filter: {
        maxHeight: "200px",
    },
    success: {
        color: "#52a850",
    },
    et_pb_row: {
        position: "relative",
        zIndex: "5",
        width: "80%",
        maxWidth: "1080px",
        margin: "auto",
    },
});

export default style;
